import { TileLayer } from "react-leaflet";

type DynamicTileLayerProps = {
  name: string;
  attribution?: string;
  url?: string;
  maxZoom?: number;
  maxNativeZoom?: number;
};

export const DEFAULT_TILE_LAYER_MAX_ZOOM = 19;

export const DynamicTileLayer = ({
  name,
  attribution,
  url,
  maxZoom,
  maxNativeZoom,
}: DynamicTileLayerProps) => {
  const isValidLayer = attribution && url;
  if (!isValidLayer) {
    console.error(
      "Missing tile parameters for tile provider %s, check your bootstrap map config",
      name,
    );
  }

  return (
    isValidLayer && (
      <TileLayer
        attribution={attribution}
        url={url}
        maxZoom={maxZoom || DEFAULT_TILE_LAYER_MAX_ZOOM}
        maxNativeZoom={maxNativeZoom}
      />
    )
  );
};
